'use client';

import ApyBreakdownTooltipV2 from 'src/components/Tooltip/ApyBreakdownTooltipV2';
import { useApyBreakdownTooltipData } from 'src/hooks/useApyBreakdownTooltipData';
import useDriftClient from 'src/hooks/useDriftClient';
import { BalanceRowData } from './types';

interface BorrowApyCellProps {
	row: BalanceRowData;
}

export function BorrowApyCell({ row }: BorrowApyCellProps) {
	const { spotMarketIndex } = row;
	const apyData = useApyBreakdownTooltipData(spotMarketIndex);
	const driftClient = useDriftClient();

	const displayApy = !driftClient
		? '--'
		: !isFinite(apyData.borrowing.totalApy) ||
			  Math.abs(apyData.borrowing.totalApy) > 1000
			? '> 1,000%'
			: `${apyData.borrowing.totalApy.toFixed(2)}%`;

	return (
		<ApyBreakdownTooltipV2
			apyChunks={apyData.borrowing.chunks}
			showTooltip={apyData.borrowing.showTooltip}
		>
			<span className="text-star-yellow">{displayApy}</span>
		</ApyBreakdownTooltipV2>
	);
}
